import type { ProgressiveSentenceNotesArgs } from './useProgressiveSentenceNotes.types';

import { useProgressiveSentenceNotesData } from './useProgressiveSentenceNotesData';
import { useProgressiveSentenceNotesQueries } from './useProgressiveSentenceNotesQueries';
import { useProgressiveSentenceNotesLoader } from './useProgressiveSentenceNotesLoader';
import { useProgressiveSentenceNotesHandlers } from './useProgressiveSentenceNotesHandlers';
import { useProgressiveSentenceNotesLifecycle } from './useProgressiveSentenceNotesLifecycle';

export const useProgressiveSentenceNotes = ({
  type,
  documentId,
  sentenceNoteId,
  onFetchComplete,
  loaderProps,
  skipReduxStorage = false
}: ProgressiveSentenceNotesArgs) => {
  const { localState, localActions, formattedData } = useProgressiveSentenceNotesData({
    type,
    documentId,
    skipReduxStorage
  });

  const queries = useProgressiveSentenceNotesQueries({
    args: {
      type,
      documentId,
      sentenceNoteId,
      onFetchComplete,
      skipReduxStorage
    },
    localState,
    localActions
  });

  const handlers = useProgressiveSentenceNotesHandlers({
    queries
  });

  useProgressiveSentenceNotesLifecycle({
    onNextSentenceNotesFetch: handlers.handleNextSentenceNotesFetch
  });

  const loader = useProgressiveSentenceNotesLoader({
    args: {
      type,
      loaderProps
    },
    localState,
    formattedData,
    queries
  });

  return {
    isFetching:
      queries.fetchSentenceNoteById.isFetching ||
      queries.fetchSentenceNotes.isFetching ||
      queries.fetchSystemGeneratedSentenceNotes.isFetching,
    sentenceNotes: formattedData.sentenceNotes,
    loader: loader
  };
};
